import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Company } from '../company/company.model';

@Injectable()
export class CompanyService {
  private companySource: BehaviorSubject<Company> = new BehaviorSubject<Company>(new Company());
  public currentCompany = this.companySource.asObservable();

  constructor() { }

  public changeCompany(company: Company) {
    this.companySource.next(company);
  }
}
